import * as types from "../types/packmate.work.types";
import { approveBulkPartialWorkApi, approveWorkApi, exportApprovalHistory, getApprovalHistory, getItemLevelInventoryFiltersPagination, getPicturePackedTime, getTaskByOrderId, getWorkDetail,
    getWorkFiltersPagination,
    getWorkList,
    orderQtyApi,
    releaseWorkApi,
} from '../../services/packmate.work.service';
import { validationErrors } from "../../utils/Helpers";

export const getWorkListAction = (data, navigate) => {

  return async (dispatch, getState)  => {
    try {
      await getWorkList(getState().authReducer.token, getState().authReducer.user.id, data).then((res) => {
        if(res.data.code === 200){
          dispatch({
            type: types.SET_WORK_DATA,
            payload: res.data.data,
          });
        }
      });
    } catch (e) {
      validationErrors(e);
    }
  };
};

export const getWorkFiltersPaginationAction = (data, signal = null) => {
  return async (dispatch, getState) => {
    try {
      const res = await getWorkFiltersPagination(
        getState().authReducer.token,
        getState().authReducer.user.id,
        data,
        signal
      );
      if (res.data.code === 200) {
        dispatch({
          type: types.SET_WORK_DATA,
          payload: res.data.data,
        });
        dispatch({
          type: types.SET_WORK_PAGINATION,
          payload: res.data.pagination || {},
        });
      }
    } catch (e) {
      if (e?.name === "Canceled" || e?.code === "ERR_CANCELED") return;
      validationErrors(e);
    }
  };
};

export const ItemLevelInventoryFiltersPagination = (data) => {
  return async (dispatch, getState) => {
    try {
      const res = await getItemLevelInventoryFiltersPagination(
        getState().authReducer.token,
        getState().authReducer.user.id,
        data
      );
      if (res.data.code === 200) {
        dispatch({
          type: types.SET_WORK_DATA,
          payload: res.data.data.data,
        });
        dispatch({
          type: types.SET_WORK_PAGINATION,
          payload: res.data.pagination || {}, // <-- separate pagination object
        });
      }
    } catch (e) {
      validationErrors(e);
    }
  };
};

export const getApprovalHistoryAction = (data, signal = null) => {
  return async (dispatch, getState) => {
    try {
      const res = await getApprovalHistory(
        getState().authReducer.token,
        getState().authReducer.user.id,
        data,
        signal
      );
      if (res.data.code === 200) {
        dispatch({
          type: types.SET_APPROVAL_HISTORY_DATA,
          payload: res.data.data,
        });
        dispatch({
          type: types.SET_APPROVAL_HISTORY_PAGINATION,
          payload: res.data.pagination || {},
        });
      }
    } catch (e) {
      if (e?.name === "Canceled" || e?.code === "ERR_CANCELED") return;
      validationErrors(e);
    }
  };
};

export const exportApprovalHistoryAction = (data) => {
  return async (dispatch, getState) => {
    const res = await exportApprovalHistory(
      getState().authReducer.token,
      getState().authReducer.user.id,
      data
    );
    const blob = new Blob([res.data], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "approval-history.csv";
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };
};

export const getWorkDetailAction = (data, navigate) => async (dispatch, getState) => {
  let request_status = false;
  let return_data = [];

  try {
    await getWorkDetail(data, getState().authReducer.token, getState().authReducer.user.id).then((res) => {
      if(res.data.code === 200){
        request_status = true;
        return_data['status'] = true;
        return_data['data'] = res.data.data;
        dispatch({
          type: types.SET_WORK_DETAIL_DATA,
          payload: res.data.data,
        });
      }
    });
  } catch (e) {
    validationErrors(e);
  }
  if (request_status) return return_data;
  else return false;
};

export const releaseWorkAction = (workId, roleType, navigate) => async (dispatch, getState) => {
  let request_status = false;
  let return_data = [];

  try {
    const token = getState().authReducer.token;
    const userId = getState().authReducer.user.id;

    // Hit POST API with workId and status "open"
    const res = await releaseWorkApi(workId, "open", roleType, token, userId);

    if (res.data.code === 200) {
      request_status = true;
      return_data['status'] = true;
      return_data['data'] = res.data.data;

      // If you want to update store with returned data
      dispatch({
        type: types.SET_WORK_DETAIL_DATA,
        payload: res.data.data,
      });

      // After success navigate to /works
      navigate("/works");
    }
  } catch (err) {
    validationErrors(err);
  }

  return request_status ? return_data : false;
};

export const updateWorkQtyAction = (payload, navigate) => async (dispatch, getState) => {
  let request_status = false;
  let return_data = [];

  try {
    const token = getState().authReducer.token;
    const userId = getState().authReducer.user.id;

    // Send the entire array as payload
    const res = await orderQtyApi(payload, token, userId);

    if (res.data.code === 200) {
      request_status = true;
      return_data['status'] = true;
      return_data['data'] = res.data.data;

      dispatch({
        type: types.SET_WORK_DETAIL_DATA,
        payload: res.data.data,
      });
    }
  } catch (err) {
    validationErrors(err);
  }

  return request_status ? return_data : false;
};

export const approveWorkAction = (orderId, status) => async (dispatch, getState) => {
  let request_status = false;
  let return_data = [];

  try {
    const token = getState().authReducer.token;
    const userId = getState().authReducer.user.id;

    // 🔹 This will confirm toggle + API trigger
    console.log("Approve Work Action Triggered:", { orderId, status });

    // Mock API call for now
    const res = await approveWorkApi(orderId, status, token, userId);

    // You’ll see console output from backend simulation once endpoint is ready
    if (res.data.code === 200) {
      request_status = true;
      return_data["status"] = true;
      return_data["data"] = res.data.data;

      dispatch({
        type: types.SET_WORK_DETAIL_DATA,
        payload: res.data.data,
      });
    }
  } catch (err) {
    console.error("Approve Work Action Error:", err);
    validationErrors(err);
  }

  return request_status ? return_data : false;
};

export const approveBulkPartialWorkAction = (items) => async (dispatch, getState) => {
  try {
    const token = getState().authReducer.token;
    const userId = getState().authReducer.user.id;
    const res = await approveBulkPartialWorkApi(items, token, userId);    
    if (res.data.code === 200) {
      dispatch({
        type: types.SET_WORK_DETAIL_DATA,
        payload: res.data.data,
      });
    }
  } catch (err) {
    validationErrors(err);
  }
};

export const getTaskByOrderIdAction = (orderId) => async (dispatch, getState) => {
  let request_status = false;
  let return_data = [];

  try {
    const token = getState().authReducer.token;
    const userId = getState().authReducer.user.id;
    const res = await getTaskByOrderId(orderId, token, userId);

    if (res.data.code === 200) {
      request_status = true;
      return_data.status = true;
      return_data.data = res.data.data;
    }
  } catch (err) {
    console.error("Failed to fetch task packer info:", err);
  }

  return request_status ? return_data : false;
};

export const getPicturePackedTimeAction = (orderRef, payload) => async (dispatch, getState) => {
  let request_status = false;
  let return_data = [];

  try {
    const token = getState().authReducer.token;
    const userId = getState().authReducer.user.id;
    const res = await getPicturePackedTime(orderRef, payload, token, userId);

    if (res.data.code === 200) {
      request_status = true;
      return_data.status = true;
      return_data.data = res.data.data;
    } else {
      validationErrors({
        response: {
          statusText: "Error",
          data: res.data,
        },
      });
    }
  } catch (err) {
    validationErrors(err);
  }

  return request_status ? return_data : false;
};